/* External Imports */
import { useState } from 'react';

/* Built In Imports */
import { Box, Divider, Image, Text, useDisclosure } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParserRemake from '@components/Utility/ArticleParser/StructuredTextParserRemake';
import {
  RemarketDrawer,
  RemarketModal,
} from '@ieo/Components/Modal/RemarketModal';
import { useMediaQuery } from 'react-responsive';

/**
 * @param {Object} sectionContent
 * @param {String} lang
 * @param {String} region
 * @returns
 */

const ProgramRemarkAbout = ({ sectionContent, region, lang }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [modalData, setModalData] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const programHeading = sectionContent?.find(
    e => e.fieldId === 'program-heading'
  );

  const DesktopView = ({ cardList, index }) => {
    return (
      <Box
        key={index}
        maxWidth="1170px"
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        mx="auto"
        w="full"
        id={`q${index + 1}`}
      >
        <Box
          maxWidth={{ base: '100%', xl: '920px' }}
          minHeight={{ md: '520px' }}
          mx={{ base: '16px', md: '30px', xl: 0 }}
          w="100%"
          bgColor="#fff"
          p={{
            md:
              index % 2 === 0
                ? '4.19rem 24.19rem 4.19rem 2.19rem'
                : '4.19rem 2.19rem 4.19rem 24.19rem',
            xl:
              index % 2 === 0
                ? '4.19rem 14.19rem 4.19rem 4.19rem'
                : '4.19rem 4.19rem 4.19rem 14.19rem',
          }}
          my="36px"
          position="relative"
          ml={{ md: '30px', xl: index % 2 !== 0 && '250px' }}
        >
          {cardList?.title && (
            <Text
              fontSize={{ base: '1.375rem', md: '2rem' }}
              lineHeight={{ base: '1.87rem', md: '2.78rem' }}
              fontFamily="FedraSansStd-book"
              color="#11146E"
              maxW={'1005px !important'}
              width={{ base: '100%', md: '96%', xl: '85%' }}
            >
              {cardList?.title}
            </Text>
          )}
          <Divider
            orientation="horizontal"
            width="100%"
            borderWidth="1px"
            borderColor="#E9DEC7"
            borderStyle="solid"
            my="1.625rem"
          />
          <StructuredTextParserRemake
            str={render(cardList.description)}
            fontSize={{ base: '1rem', md: '1.125rem' }}
            lineHeight={{ base: '1.75rem', md: '2rem' }}
            fontFamily="FedraSansStd-book"
            maxW={'1005px !important'}
            width="100%"
            mx="auto"
            color="#000000"
          />

          {cardList?.buttonText && (
            <Text
              display="flex"
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
              width="191px"
              height="50px"
              mt="2.625rem"
              textAlign="center"
              color="#fff"
              fontSize={{ base: '1rem', md: '1.25rem' }}
              lineHeight={{ base: '1.75rem', md: '1.56rem' }}
              fontFamily="FedraSansStd-medium"
              borderRadius={'50px'}
              background={'#F37021'}
              onClick={() => {
                onOpen();
                setModalData(cardList);
              }}
            >
              {cardList?.buttonText}
            </Text>
          )}

          <Box
            width={{ md: '340px', xl: '411px' }}
            position={'absolute'}
            right={{
              md: index % 2 === 0 && '10px',
              xl: index % 2 === 0 && '-220px',
            }}
            left={{
              md: index % 2 !== 0 && '30px',
              xl: index % 2 !== 0 && '-220px',
            }}
            zIndex={1}
            top="10%"
          >
            <Image
              src={cardList?.thumbnail?.url}
              alt={cardList?.thumbnail?.alt}
            />
          </Box>
        </Box>
      </Box>
    );
  };

  const MobileView = ({ cardList, index }) => {
    return (
      <Box
        key={index}
        // maxWidth="1170px"
        // maxHeight="834px"
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        flexDirection="column"
        position="relative"
        mx="auto"
        mt={{ base: '8rem', md: '10rem' }}
        mb={{ base: '8rem', md: '0rem' }}
        id={`q${index + 1}`}
        style={{
          scrollMarginTop: '130px',
        }}
      >
        <Box
          maxWidth={{ base: '100%', md: '735px', lg: '100%' }}
          bgColor="#fff"
          p="10.19rem 1rem 2rem 1rem"
          position="relative"
          minWidth={{ base: '300px', sm: '390px', md: '735px' }}
        >
          <Text
            fontSize={{ base: '1.375rem', md: '2rem' }}
            lineHeight={{ base: '1.87rem', md: '2.78rem' }}
            fontFamily="FedraSansStd-book"
            color="#11146E"
            textAlign="center"
            maxW={'1005px !important'}
            width={{ base: '100%', md: '85%' }}
          >
            {cardList?.title}
          </Text>
          <Divider
            orientation="horizontal"
            width="100%"
            borderWidth="1px"
            borderColor="#E9DEC7"
            borderStyle="solid"
            my="1rem"
          />
          <StructuredTextParserRemake
            str={render(cardList?.description)}
            fontSize={{ base: '1rem', md: '1.125rem' }}
            lineHeight={{ base: '1.75rem', md: '2rem' }}
            fontFamily="FedraSansStd-book"
            maxW={'1005px !important'}
            width="100%"
            textAlign="center"
            mx="auto"
            px="10px"
          />

          {cardList?.buttonText && (
            <Text
              display="flex"
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
              width="191px"
              height="50px"
              mt="2.625rem"
              textAlign="center"
              color="#fff"
              fontSize={{ base: '1rem', md: '1.25rem' }}
              lineHeight={{ base: '1.75rem', md: '1.56rem' }}
              fontFamily="FedraSansStd-medium"
              borderRadius={'50px'}
              background={'#F37021'}
              onClick={() => {
                onOpen();
                setModalData(cardList);
              }}
              mx="auto"
            >
              {cardList?.buttonText}
            </Text>
          )}
        </Box>
        <Box width="235px" position="absolute" top="-100px">
          <Image
            src={cardList?.thumbnail?.url}
            alt={cardList?.thumbnail?.alt}
          />
        </Box>
      </Box>
    );
  };

  return (
    <Box
      bgImg={'https://static.sadhguru.org/d/46272/1733516221-81185-1.png'}
      bgColor="#F1EBDF96"
      bgRepeat="no-repeat"
      bgPos="-70% -30px"
    >
      <Box
        p={{ base: '3.563rem 1rem', md: '8.688rem 1rem' }}
        borderRadius="lg"
        color={'#525252'}
        maxWidth="1920px"
        mx="auto"
      >
        {/* Centered Heading */}
        {programHeading && (
          <StructuredTextParserRemake
            str={render(programHeading?.body)}
            fontSize={{ base: '1.625rem', md: '3.25rem' }}
            lineHeight={{ base: '2.015rem', md: '3.9rem' }}
            fontFamily="FedraSansStd-medium"
            textAlign="center"
            maxW={'1005px !important'}
            width="100%"
            mx="auto"
            className="program-heading-text"
            mb={{ base: '10rem', md: '6rem' }}
            px={{ base: '1px', md: '5px', lg: '0px' }}
          />
        )}
        {/* About Program Card right side images */}
        {isMobile
          ? sectionContent[1]?.cards.map((cardList, index) => (
              <MobileView cardList={cardList} index={index} key={index} />
            ))
          : sectionContent[1]?.cards.map((cardList, index) => (
              <DesktopView cardList={cardList} index={index} key={index} />
            ))}
      </Box>

      {modalData !== null &&
        isOpen &&
        (isMobile ? (
          <RemarketDrawer
            lang={lang}
            divider={true}
            isOpen={isOpen}
            onClose={onClose}
            modalData={modalData}
          />
        ) : (
          <RemarketModal
            divider={true}
            isOpen={isOpen}
            onClose={onClose}
            modalData={modalData}
          />
        ))}
      <style>
        {`
        .program-heading-text mark{
          background: none;
          color:#12166F;
        }
        .program-heading-text h2{
          color:#F37021;
        }
      `}
      </style>
    </Box>
  );
};

export default ProgramRemarkAbout;
